/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ComplianceTimelineEventPayload } from './';
import {
    ComplianceTimelineEventPayloadFromJSON,
    ComplianceTimelineEventPayloadFromJSONTyped,
    ComplianceTimelineEventPayloadToJSON,
} from './';

/**
 * 
 * @export
 * @interface KycStatusTimelinePayload
 */
export interface KycStatusTimelinePayload extends ComplianceTimelineEventPayload {
    /**
     * 
     * @type {boolean}
     * @memberof KycStatusTimelinePayload
     */
    compliant: boolean;
}

/**
 * Check if a given object implements the KycStatusTimelinePayload interface.
 */
export function instanceOfKycStatusTimelinePayload(value: object): value is KycStatusTimelinePayload {
    if (!('compliant' in value) || value['compliant'] === undefined) return false;
    return true;
}

export function KycStatusTimelinePayloadFromJSON(json: any): KycStatusTimelinePayload {
    return KycStatusTimelinePayloadFromJSONTyped(json, false);
}

export function KycStatusTimelinePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): KycStatusTimelinePayload {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadFromJSONTyped(json, ignoreDiscriminator),
        'compliant': json['compliant'],
    };
}

export function KycStatusTimelinePayloadToJSON(value?: KycStatusTimelinePayload | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadToJSON(value, true),
        'compliant': value['compliant'],
    };
}

